<div class="card-round margin-16 page-card">
    <h2 class="noMargin">Administrationsverwaltung | Zu Prüfende Locations</h2>

    <div class="margin-top-32">
        <ng-container *ngIf="filteredLocatios.length !== 0">
            <app-location-card *ngFor="let location of filteredLocatios; index as i;" [location]="location" (examinationResult)="onExaminationResult($event)"></app-location-card>
        </ng-container>
        <div *ngIf="filteredLocatios.length === 0">Es sind keine Locations zum überprüfen vorhanden</div>
    </div>
</div>